"use client";

// src/hooks/use-is-mobile.ts
import { useEffect, useState } from "react";
var MOBILE_BREAKPOINT = 768;
var useIsMobile = () => {
  const [isMobile, setIsMobile] = useState();
  useEffect(() => {
    const mql = globalThis.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => {
      mql.removeEventListener("change", onChange);
    };
  }, []);
  return !!isMobile;
};

export {
  useIsMobile
};
